import OnScreen from 'onscreen';

export default {
    init() {
        const os = new OnScreen();
        os.on('enter', '.add_fadeInUp ', (element) => {
            if (element.classList.contains('add_fadeInUp') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInUp');
                element.className += ' fadeInUp  show';
            }
        });


    },
    finalize() {
    },
};




// WEBPACK FOOTER //
// ./scripts/routes/clients.js